module.exports = __webpack_public_path__ + "img/logo-properfy.87b8cb49.svg";